var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group2",
    transform: "translate(-93.000000, -532.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group3",
    transform: "translate(93.000000, 532.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "pages-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5405405,25.8498498 L28.5405405,7.01501502 C28.5405405,5.53513514 27.3297297,4.32432432 25.8498498,4.32432432 L7.01501502,4.32432432 C5.53513514,4.32432432 4.32432432,5.53513514 4.32432432,7.01501502 L4.32432432,25.8498498 C4.32432432,27.3297297 5.53513514,28.5405405 7.01501502,28.5405405 L25.8498498,28.5405405 C27.3297297,28.5405405 28.5405405,27.3297297 28.5405405,25.8498498 Z",
    id: "pages-icon-path1",
    fill: "#FF9903",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group4",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4812023,8.66211649 C3.26842747,8.87489042 2.96774203,9.25988678 2.81302322,9.51807453 L1.23773099,12.1433237 L1.85660622,12.7621964 L4.4819636,11.187008 C4.73995793,11.0321925 5.12515038,10.7314111 5.33782796,10.5188317 L8.66442815,7.19234258 L6.80770524,5.33553016 L3.4812023,8.66211649 Z",
    id: "pages-icon-path2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group5",
    transform: "translate(7.426542, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pages-icon-mask1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "pages-icon-polygon2",
    points: "0 0 6.57345844 0 6.57345844 7.92047095 0 7.92047095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pages-icon-group6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20397265,7.81106936 L3.20397265,7.12023478 C3.20397265,6.84833536 3.36666565,6.45604557 3.55862977,6.2637905 L5.87970359,3.94301809 C6.13546127,3.687067 6.13546127,3.27066023 5.87970359,3.01470913 L5.64757676,2.78268051 L6.18894671,2.24121557 C6.70162901,1.72853541 6.70162901,0.897180565 6.18894671,0.384500399 C5.67626441,-0.128179766 4.8449061,-0.128179766 4.33232105,0.384500399 L0,4.71670614 L1.85672291,6.57332407 L5.49256622,2.93730143 L5.72498479,3.16942729 C5.89555473,3.34009377 5.89555473,3.6177307 5.72498479,3.78829993 L3.40400821,6.10916959 C3.16915849,6.34401834 2.98507131,6.78814017 2.98507131,7.12023478 L2.98507131,7.81106936 C2.98507131,7.84131282 2.99742158,7.86863891 3.01706533,7.88847706 C3.03690357,7.90831522 3.06422977,7.92047095 3.09447336,7.92047095 C3.15496053,7.92047095 3.20397265,7.87155628 3.20397265,7.81106936",
    id: "pages-icon-path3",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "pages-icon-polygon3",
    fill: "#FFFFFF",
    points: "0 14 1.16034242 13.3037197 0.696380494 12.8396624"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesIcon);
export default __webpack_public_path__ + "static/media/pages-icon.2a712ea0.svg";
export { ForwardRef as ReactComponent };